/*=============================================== TextIconPage ===============================================*/

import { TextIcon } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const TextIconPage = () => {
    const items: ItemType[] = [
        {
            content: <TextIcon icon="arrow-right">Hello</TextIcon>,
            code: '<TextIcon icon="arrow-right">Hello</TextIcon>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "textAs",
            intro: "Changes the HTML tag for the Text element",
            type: "string",
            possibleString: "Any HTML tag",
            default: <>Same as tag prop</>,
        },
        {
            subtitle: "icon",
            intro: commonProps.addIconCapital,
            type: "string",
            required: true,
        },
        {
            subtitle: "iconColor",
            type: "string",
            possibleString: commonProps.allColors,
            default: "currentColor",
        },
        {
            subtitle: "iconSize",
            type: "number",
            default: (
                <>
                    It depends on the tag, the <code>iconSize</code> being the
                    same value as the <code>line-height</code>.
                </>
            ),
        },
        {
            subtitle: "tag",
            type: "string",
            possible: [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "p",
                "small",
                "blockquote",
            ],
            default: "p",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default TextIconPage
